import { msg } from '@lingui/macro';

export const SettingsRoutes = {
  path: '/settings',
  lazy: () => import('pages/settings/Settings.page'),
  // Title belongs in Topbar (same pattern as Styles / Subsuppliers) — dl-62374.
  handle: {
    name: 'Settings',
    category: 'Settings',
    title: msg`Settings`,
  },
};
